import executeUnAuthApi from './executeUnAuthApi ';
import { SystemError, SystemErrorTitle, SystemErrorMsg } from "../../constants";

/** 認証取得 */
const getAuthLog = async (
    contractId: string,
) => {

    // SmeFrontAPIのURLを取得
    const baseURL = process.env.REACT_APP_EYES_FRONT_API_ROOT!;
    const apiKey = process.env.REACT_APP_EYES_FRONT_API_KEY!;
    // セッション確認API PATH
    const path = "/auth/authlog/execution";
    const request = {
        "contractId": contractId
    };

    try {
        const response = await executeUnAuthApi(baseURL, apiKey, path, 0, request);
        // レスポンスコード返却
        if (!response || response.data.res_cd == "") {
            return {
                resCd: SystemError,
                msgTitle: SystemErrorTitle,
                msg: SystemErrorMsg,
                data: {}
            }
        } else {
            return response.data
        }
    } catch (e) {
        return {
            resCd: SystemError,
            msgTitle: SystemErrorTitle,
            msg: SystemErrorMsg,
            data: {}
        }
    }
};

export default getAuthLog;
